import React from 'react'
import PDFIcon from 'assets/icons/pdf.svg'
import styled from 'styled-components'
import { useToggleState } from 'lib/hooks/useToggleState'
import { useTranslation } from 'next-i18next'
import FeatureDialog from 'stories/elements/Modal/DialogWindow/FeatureDialog'
import theme from 'stories/utils/theme'
import dynamic from 'next/dynamic'

const PDFViewer = dynamic(() => import('components/modules/PDFPreview/PDFViewer'), { ssr: false })

const Container = styled.div<{ isBig?: boolean }>`
    width: ${({ isBig }) => (isBig ? 300 : 150)}px;
    height: ${({ isBig }) => (isBig ? 300 : 150)}px;
    border-radius: 5px;
    position: relative;

    background-size: contain;
    background-position: center;
    margin-right: 10px;
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.4);
    cursor: pointer;

    svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        fill: white;
        width: 30px;
        height: 30px;
    }
`

const Type = styled.p`
    margin: 0;
    position: absolute;
    top: 5px;
    left: 5px;
    background: rgba(0, 0, 0, 0.4);
    color: white;
    padding: 4px 6px;
    border-radius: 3px;
    font-size: 0.75em;
`

const ModalContent = styled.div`
    & img {
        width: 100%;
    }
`

interface Props {
    contentType: 'PDF' | 'IMAGE'
    previewUrl: string
    onClick?: (contentType: 'PDF' | 'IMAGE') => void
    isBig?: boolean
    interceptPreview?: boolean
}

const ContentPreview = (props: Props) => {
    const [showModal, toggleShowModal] = useToggleState(false)
    const { t: tCommon } = useTranslation('common')

    let backgroundColor: string | null = null
    let icon: JSX.Element | null = null

    switch (props.contentType) {
        case 'PDF':
            backgroundColor = theme.colors.deepSeaBlue
            icon = <PDFIcon />
            break
        case 'IMAGE':
            backgroundColor = '#fff'
            break
        default:
            backgroundColor = '#fff'
    }

    const onContentClick = () => {
        props?.onClick && props.onClick(props.contentType)
        !props.interceptPreview && toggleShowModal()
    }

    return (
        <>
            <Container
                isBig={props.isBig}
                onClick={onContentClick}
                style={{
                    backgroundImage: `url(${props.previewUrl})`,
                    backgroundColor: backgroundColor,
                    backgroundSize: 'cover',
                }}
            >
                <Type>{props.contentType}</Type>
                {icon}
            </Container>
            <FeatureDialog
                open={showModal}
                onClose={toggleShowModal}
                ariaPrefix="content-preview"
                allowVerticalOverflow
                allowHorizontalOverflow
                maxWidth={800}
                title=""
            >
                <ModalContent>
                    {props.contentType === 'PDF' ? (
                        <PDFViewer pdfUrl={props.previewUrl} showOverflow={true} disableExperiments />
                    ) : null}
                    {props.contentType === 'IMAGE' ? (
                        <img src={props.previewUrl} alt={tCommon('common/imagePreview')} />
                    ) : null}
                </ModalContent>
            </FeatureDialog>
        </>
    )
}

export default ContentPreview
